import { render, staticRenderFns } from "./cModalMetodo.vue?vue&type=template&id=544e1640"
import script from "./cModalMetodo.vue?vue&type=script&lang=js"
export * from "./cModalMetodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports